import React from "react";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Button, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

type Props = React.ComponentProps<typeof Button>;

const useStyles = makeStyles()((theme: Theme) => ({
  weightButton: {
    border: "2px solid #D4DBE5",
    "&:hover": {
      border: "2px solid #1FD4AF",
    },
    fontSize: "12px",
    width: "115px",
  },
}));

const AddWeightButton: React.FC<Props> = (props) => {
  const { classes } = useStyles();
  return (
    <Button
      {...props}
      size="small"
      variant="outlined"
      startIcon={<AddRoundedIcon fontSize="small" />}
      className={classes.weightButton}
    >
      Add Weight
    </Button>
  );
};

export default AddWeightButton;
